import React, { FC, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Stack, TextFieldProps } from '@mui/material';
import { SDateLabel, STextField } from './styles';
import SvgIconStyle from '../SvgIconStyle';
import { DatePicker } from '@mui/lab';

type Props = {
  leftName: string;
  rightName: string;
  minDate?: Date;
};

const RHFGroupDateField: FC<Props & TextFieldProps> = ({
  leftName,
  rightName,
  minDate,
  ...other
}) => {
  const { control, setValue, getValues } = useFormContext();
  const [openFrom, setOpenFrom] = useState(false);
  const handleOpenFrom = () => {
    setOpenFrom(true);
  };
  const handleCloseFrom = () => {
    setOpenFrom(false);
  };

  const [openTo, setOpenTo] = useState(false);
  const handleOpenTo = () => {
    setOpenTo(true);
  };
  const handleCloseTo = () => {
    setOpenTo(false);
  };

  return (
    <Stack direction="row" maxWidth="500px">
      <SDateLabel start>
        <SvgIconStyle
          src="/icons/iconly/light/calendar.svg"
          sx={{ position: 'absolute', left: 5, width: '30px' }}
        />
      </SDateLabel>
      <Controller
        name={leftName}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            open={openFrom}
            onOpen={handleOpenFrom}
            onClose={handleCloseFrom}
            value={getValues(field.name)}
            onChange={(newValue) =>
              setValue(field.name, newValue?.toLocaleDateString('en-US') || '')
            }
            minDate={minDate}
            renderInput={(params) => (
              <STextField
                startHint={true}
                endHint={false}
                firstInput={true}
                inputRef={params.inputRef}
                {...other}
                {...field}
                error={!!error}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: null,
                }}
                onClick={handleOpenFrom}
                helperText={error?.message}
                placeholder="from"
                size="small"
              />
            )}
          />
        )}
      />
      <Controller
        name={rightName}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            open={openTo}
            onOpen={handleOpenTo}
            onClose={handleCloseTo}
            value={getValues(field.name)}
            onChange={(newValue) =>
              setValue(field.name, newValue?.toLocaleDateString('en-US') || '')
            }
            minDate={minDate}
            renderInput={(params) => (
              <STextField
                startHint={true}
                endHint={false}
                firstInput={false}
                inputRef={params.inputRef}
                {...other}
                {...field}
                error={!!error}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: null,
                }}
                onClick={handleOpenTo}
                helperText={error?.message}
                placeholder="to"
                size="small"
              />
            )}
          />
        )}
      />
    </Stack>
  );
};

export default RHFGroupDateField;
